import request from '@/utils/request'

// 提交异步导出任务
export function submitExport(type, params) {
  return request({ url: `/api/export/submit?type=${type}`, method: 'post', data: params })
}

// 查询导出任务状态
export function getExportTask(taskId) {
  return request({ url: `/api/export/task/${taskId}`, method: 'get' })
}

// 下载导出文件
export function downloadExport(taskId) {
  return request({
    url: `/api/export/download/${taskId}`,
    method: 'get',
    responseType: 'blob',
    timeout: 120000
  })
}

// 删除导出任务
export function deleteExportTask(taskId) {
  return request({ url: `/api/export/task/${taskId}`, method: 'delete' })
}

